import { render, staticRenderFns } from "./PoundageSet.vue?vue&type=template&id=2183e733&scoped=true&"
import script from "./PoundageSet.vue?vue&type=script&lang=js&"
export * from "./PoundageSet.vue?vue&type=script&lang=js&"
import style0 from "./PoundageSet.vue?vue&type=style&index=0&id=2183e733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183e733",
  null
  
)

export default component.exports